/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ClaimsSchemaFieldBooleanValue } from './ClaimsSchemaFieldBooleanValue';
import { ClaimsSchemaFieldDateTimeValue } from './ClaimsSchemaFieldDateTimeValue';
import { ClaimsSchemaFieldDateValue } from './ClaimsSchemaFieldDateValue';
import { ClaimsSchemaFieldFileValue } from './ClaimsSchemaFieldFileValue';
import { ClaimsSchemaFieldLinkValue } from './ClaimsSchemaFieldLinkValue';
import { ClaimsSchemaFieldNumberValue } from './ClaimsSchemaFieldNumberValue';
import { ClaimsSchemaFieldStringValue } from './ClaimsSchemaFieldStringValue';

export const ClaimsSchemaFieldStructOptionalValueFieldsItem: core.serialization.Schema<
    serializers.ClaimsSchemaFieldStructOptionalValueFieldsItem.Raw,
    Truvity.ClaimsSchemaFieldStructOptionalValueFieldsItem
> = core.serialization
    .union('kind', {
        BOOLEAN: ClaimsSchemaFieldBooleanValue,
        DATE: ClaimsSchemaFieldDateValue,
        DATETIME: ClaimsSchemaFieldDateTimeValue,
        FILE: ClaimsSchemaFieldFileValue,
        LINK: ClaimsSchemaFieldLinkValue,
        NUMBER: ClaimsSchemaFieldNumberValue,
        STRING: ClaimsSchemaFieldStringValue,
        STRUCT: core.serialization.lazyObject(() => serializers.ClaimsSchemaFieldStructOptionalValue),
    })
    .transform<Truvity.ClaimsSchemaFieldStructOptionalValueFieldsItem>({
        transform: (value) => value,
        untransform: (value) => value,
    });

export declare namespace ClaimsSchemaFieldStructOptionalValueFieldsItem {
    export type Raw =
        | ClaimsSchemaFieldStructOptionalValueFieldsItem.Boolean
        | ClaimsSchemaFieldStructOptionalValueFieldsItem.Date
        | ClaimsSchemaFieldStructOptionalValueFieldsItem.Datetime
        | ClaimsSchemaFieldStructOptionalValueFieldsItem.File
        | ClaimsSchemaFieldStructOptionalValueFieldsItem.Link
        | ClaimsSchemaFieldStructOptionalValueFieldsItem.Number
        | ClaimsSchemaFieldStructOptionalValueFieldsItem.String
        | ClaimsSchemaFieldStructOptionalValueFieldsItem.Struct;

    export interface Boolean extends ClaimsSchemaFieldBooleanValue.Raw {
        kind: 'BOOLEAN';
    }

    export interface Date extends ClaimsSchemaFieldDateValue.Raw {
        kind: 'DATE';
    }

    export interface Datetime extends ClaimsSchemaFieldDateTimeValue.Raw {
        kind: 'DATETIME';
    }

    export interface File extends ClaimsSchemaFieldFileValue.Raw {
        kind: 'FILE';
    }

    export interface Link extends ClaimsSchemaFieldLinkValue.Raw {
        kind: 'LINK';
    }

    export interface Number extends ClaimsSchemaFieldNumberValue.Raw {
        kind: 'NUMBER';
    }

    export interface String extends ClaimsSchemaFieldStringValue.Raw {
        kind: 'STRING';
    }

    export interface Struct extends serializers.ClaimsSchemaFieldStructOptionalValue.Raw {
        kind: 'STRUCT';
    }
}
